import React, { useEffect } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import useAboutYou from "../../hooks/useAboutYou"
import { StepLayout } from "#/components/carrot-plans/shared/StepLayout"
import { ButtonFooterLayout, ContinueButton } from "#/components/carrot-plans/shared/ButtonFooter"
import { FormattedMessage, useIntl } from "react-intl"
import { FormDatePicker, Form } from "@carrotfertility/carotene-core-x"
import { dayjs } from "@carrotfertility/carotene-core"
import { validateMemberDOB } from "#/services/common-forms"
import { RoutingFlowTitle } from "#/components/carrot-plans/shared"
import { carrotClient } from "#/utils/CarrotClient"
import { useCurrentUser } from "#/components/context/user/UserContext"

export default function AboutYouDobStep(): JSX.Element {
  const intl = useIntl()
  const userInfo = useCurrentUser()
  const { data: aboutYouQueryData, updateAboutYou, isLoading: aboutYouQueryIsLoading } = useAboutYou()
  const { send } = useStateMachine(aboutYouQueryData?.dateOfBirth ? "" : null)
  async function onClickContinue({ dateOfBirth }: { dateOfBirth?: dayjs.Dayjs }): Promise<void> {
    await updateAboutYou({ dateOfBirth: dateOfBirth.format("YYYY-MM-DD") })
    send("")
  }
  const header = intl.formatMessage({
    defaultMessage: "When were you born?"
  })

  useEffect(() => {
    const startRouting = async () => {
      try {
        await carrotClient.startCarrotPlansEnrollment()
        userInfo.refreshUserInfo()
      } catch (error) {
        reportError(error)
      }
    }

    if (userInfo?.carrotPlansRoutingStarted === null) {
      startRouting()
    }
  }, [userInfo])

  return aboutYouQueryIsLoading ? null : (
    <>
      <RoutingFlowTitle title={header} />
      <StepLayout
        header={header}
        formElements={
          <Form defaultValues={{ dateOfBirth: dayjs(aboutYouQueryData?.dateOfBirth) }} onSubmit={onClickContinue}>
            <FormDatePicker
              name="dateOfBirth"
              controllerProps={{
                rules: {
                  required: intl.formatMessage({ defaultMessage: "Required" }),
                  validate: (value: dayjs.Dayjs) => {
                    const result = validateMemberDOB(value)
                    if (typeof result !== "boolean") {
                      return intl.formatMessage(result)
                    }
                    return result
                  }
                }
              }}
              label={intl.formatMessage({ defaultMessage: "Date of birth" })}
            />
            <ButtonFooterLayout
              continueButton={
                <ContinueButton>
                  <FormattedMessage defaultMessage="Continue" />
                </ContinueButton>
              }
            />
          </Form>
        }
      />
    </>
  )
}
